<template>
  <div>
    <nav-breadcrumb :menu="[{label: '客户合同申请详情'}]"/>
    <el-tabs class="bg-purple" v-model="tabName">
      <el-tab-pane label="申请信息" name="summary">
        <contract-applying-detail-component :contractApplyingDetail="contractApplyingDetail"/>
        <form-build
          v-if="contractApplyingDetail.ct__applicationStatus== 'Pending Approval'"
          form-name="approveContractForm"
          :form-data="approveContractForm"
          :form-columns-group = "approveContractFormColumnsGroups"
          :form-rules="approveContractFormRules"
          :form-buttons = "approveContractFormButtons"
          label-width="200px"
        ></form-build>
      </el-tab-pane>
      <el-tab-pane label="审批流程" name="second">审批流程</el-tab-pane>
    </el-tabs>
    <button-back class="xzmt"></button-back>
  </div>
</template>

<script>
  import xhr from '../../../utils/xhr'
  import ButtonBack from '../../../components/ButtonBack'
  import FormBuild from '../../../components/FormBuild'
  import ContractApplyingDetailComponent from '../../components/ContractApplyingDetailComponent'
  import Status2CN from "../../../filters/Status2CN";

  export default {
    name: "ContractApplyingDetail",
    data() {
      return {
        tabName: 'summary',
        contractApplyingDetail: {
        },
        approveContractForm: {
          "ct__applicationId": this.$route.query['ct.applicationId']||'',
          "a__approvingStatus": "",
          "a__remarks": "",
          "ax__approvedContractValidity": [],
          "ax__approvedContractValidity1": "",
          "ax__approvedContractValidity2": "",
          "ax__approvedInterestPayTime": "",
          "ax__approvedInterestRate": "",
          "ax__approvedInterestType": "",
          "ax__approvedLendingFee": "",
          "ax__approvedLendingFeeType": "",
          "ax__approvedLendingFeePayTime": "",

        },
        approveContractFormColumnsGroups: [
          {
            label: '合同签署结果',
            columns: [
              {
                label: '合同起始到期日',
                component: 'date-range-picker',
                field: 'ax__approvedContractValidity',
                valueFormat: 'yyyy-MM-dd',
                span:24
              },
              {
                label: '服务费',
                field: 'ax__approvedLendingFee',
                formatter: function (r,v) {
                  return v + (r.ax__approvedLendingFeeType == 'Rate' ? '%' : '元') + ' 收取方式：' + Status2CN(r.ax__approvedLendingFeeType)
                }
              },
              {
                label: '融资利率',
                field: 'ax__approvedInterestRate',
                formatter: function (r,v) {
                  return v + '% ' +  Status2CN(r.ax__approvedInterestType)
                }
              },
/*              {
                label: '服务费（%）',
                component: 'el-input',
                field: 'ax__approvedLendingFee',
                type: 'text'
              },
              {
                label: '融资月利率（%）',
                component: 'el-input',
                field: 'ax__approvedInterestRate',
                type: 'text'
              },
              {
                label: '利息收取节点',
                component: 'el-select',
                field: 'ax__approvedInterestPayTime',
                options: [
                  {
                    label: '还款时收取',
                    value: '还款时收取'
                  }
                ]
              },
              {
                label: '费用收取节点',
                component: 'el-select',
                field: 'ax__approvedLendingFeePayTime',
                options: [
                  {
                    label: '还款时收取',
                    value: '还款时收取'
                  }
                ]
              }*/
            ]
          },
          {
            label: '',
            columns: [
              {
                label: '审核意见',
                field: 'a__remarks',
                component: 'el-input',
                type: 'textarea',
                span: 24
              }
            ]
          }
        ],
        approveContractFormRules: {
          ax__approvedContractValidity: [
            {
              required: true,
              message: '此项不能为空'
            }
          ],
          ax__approvedInterestRate: [
            {
              required: true,
              message: '此项不能为空'
            }
          ],
          ax__approvedLendingFee: [
            {
              required: true,
              message: '此项不能为空'
            }
          ],
          ax__approvedLendingFeePayTime: [
            {
              required: true,
              message: '此项不能为空'
            }
          ],
          ax__approvedInterestPayTime: [
            {
              required: true,
              message: '此项不能为空'
            }
          ]
        },
        approveContractFormButtons: [
          {
            label: '审核通过',
            type: 'primary',
            clickHandler: $refs=> {
              this.onSubmit($refs, 'Approved')
            }
          },
          {
            label: '否决',
            type: '',
            clickHandler: $refs=> {
              this.onSubmit($refs, 'Rejected')
            }
          }
        ]
      }
    },
    components: {
      ContractApplyingDetailComponent,
      FormBuild,
      ButtonBack
    },
    computed: {
      filterParams: function() {
        return {
          'ct.applicationId': this.$route.query['ct.applicationId']
        }
      }
    },
    mounted() {
      this.getCustomerApplyingContractDetail()
    },
    methods: {
      getCustomerApplyingContractDetail: function () {
        xhr.getCustomerApplyingContractDetail(
          this.filterParams,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.contractApplyingDetail = res.data.data
                this.approveContractForm.ax__approvedLendingFee = this.contractApplyingDetail.ct__expectedLendingFee;
                this.approveContractForm.ax__approvedLendingFeeType = this.contractApplyingDetail.ct__expectedLendingFeeType;
                this.approveContractForm.ax__approvedInterestRate = this.contractApplyingDetail.ct__expectedInterestRate;
                this.approveContractForm.ax__approvedInterestType = this.contractApplyingDetail.ct__expectedInterestType;
                this.approveContractForm.ax__approvedInterestPayTime = this.contractApplyingDetail.ct__expectedInterestPayTime
                this.approveContractForm.ax__approvedLendingFeePayTime = this.contractApplyingDetail.ct__expectedLendingFeePayTime
              }
            }catch (e) {

            }
          }
        )
      },
      updateCustomerApproveContract: function () {
        xhr.updateCustomerApproveContract(
          this.approveContractForm,
          res=> {
            try{
              if(res.data.status == 'success') {
                this.$router.push({
                  name: 'ServerAdminContractApplyingList'
                })
              }
            }catch (e) {

            }
          }
        )
      },
      onSubmit: function ($refs, approvingStatus) {
        this.approveContractForm.a__approvingStatus = approvingStatus
        this.approveContractForm.ax__approvedContractValidity1 = this.approveContractForm.ax__approvedContractValidity[0]
        this.approveContractForm.ax__approvedContractValidity2 = this.approveContractForm.ax__approvedContractValidity[1]

        if(approvingStatus == 'Approved') {
          $refs.validate((valid)=> {
            if (valid) {
              this.updateCustomerApproveContract()
            }
            else {
            }
          })
        }
        else {
          this.updateCustomerApproveContract()
        }
      }
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/lender/ServiceAdmin/ContractApplyingDetail.vue